/* eslint-disable sort-imports,sonarjs/cognitive-complexity */

class DocumentationItem {
  constructor(block) {
    this.block = block;

    this.selectors = {
      categoryHeader: '.b-documentation__filters-category-header',
      categoryTemplate: '.b-documentation__filters-category-template',
      filtersSelect: '.b-documentation__filters-select',
      filtersSelectRadio: '.b-documentation__filters-select-radio',
      filtersSelectRadioChecked: '.b-documentation__filters-select-radio:checked',
      filtersSelectRadioCatergory:
        '.b-documentation__filters-select-radio--category',
      filtersQueryInput: '.b-documentation__filters-query-input',
      pagingBar: '.c-paging-bar',
      pageLimit: '.b-documentation__paging-size-number-select',
      selectDocumentType: '.b-documentation__selector-select--document-type',
      statusSelected: '[name="status"]:checked',
      statusLatest: '[name="status"][value="publish"]',
      offset: '.b-documentation__paging-state-offset',
      reset: '.b-documentation__filters-reset',
      row: '.b-documentation__table-row',
      pagingTotal: '.b-documentation__paging-state-total',
      pagingCurrent: '.b-documentation__paging-state-current',
      headerCellInner: '.b-documentation__table-header-cell-inner',
      category1: '[name=category_1]',
      category2: '[name=category_2]',
      category3: '[name=category_3]',
      category1Checked: '[name=category_1]:checked',
      category2Checked: '[name=category_2]:checked',
      category3Checked: '[name=category_3]:checked',
      tableBody: 'tbody',
      categories: '.b-documentation__filters-categories',
      filtersSelectLabel: '.b-documentation__filters-select-label',
      tooltip: '.b-documentation__tooltip',
      tooltipText: '.b-documentation__tooltip-text',
      radioStatus: '[name="status"]',
      notices: '.b-documentation__notices',
      notice: '.b-documentation__notice',
      noticeArchived: '.b-documentation__notice--archived',
      noticeClose: '.b-documentation__notice-close',
    };

    this.classes = {
      rowHidden: 'b-documentation__table-row--hidden',
      resetHidden: 'b-documentation__filters-reset--hidden',
      tooltipHidden: 'b-documentation__tooltip--hidden',
      noticeHidden: 'b-documentation__notice--hidden',
      page: 'c-paging-bar__page',
      pageArrow: 'c-paging-bar__page--arrow',
      pagePrev: 'c-paging-bar__page--prev',
      pageNext: 'c-paging-bar__page--next',
      pageDisabled: 'c-paging-bar__page--disabled',
      pageEllipsis: 'c-paging-bar__ellipsis',
      pageSelected: 'c-paging-bar__page--selected',
    };

    this.bootstrap();
  }

  bootstrap() {
    const categoryN1 = this.block.querySelector(
      this.selectors.category1Checked,
    );

    this.categoriesDefault = [ categoryN1 ? categoryN1.value : false ];

    this.categoryDefault =
      this.categoriesDefault[this.categoriesDefault.length - 1];

    const filtersSelectRadio = [
      ...this.block.querySelectorAll(this.selectors.filtersSelectRadio),
      this.block.querySelector(this.selectors.filtersQueryInput),
      this.block.querySelector(this.selectors.selectDocumentType),
    ];

    const pageLimit = this.block.querySelector(this.selectors.pageLimit);

    pageLimit.addEventListener('change', () => {
      this.block.querySelector(this.selectors.offset).value = 0;
      this.triggerChange();

      setTimeout(() => {
        const elementRect = pageLimit.getBoundingClientRect();
        const middle = elementRect.top + window.scrollY - (window.innerHeight / 2);

        window.scrollTo({
          top: middle,
          behavior: 'smooth',
        });
      }, 100);
    });

    filtersSelectRadio.forEach(radio => {
      radio.addEventListener('change', () => this.triggerChange());
      radio.addEventListener('keyup', () => this.triggerChange());
    });

    const reset = this.block.querySelector(this.selectors.reset);

    reset.addEventListener('click', () => this.resetFilters());

    const headerCellInner = [
      ...this.block.querySelectorAll(this.selectors.headerCellInner),
    ];

    headerCellInner.forEach(cell => {
      cell.addEventListener('click', () =>
        this.sortBy(cell.dataset.sortBy, cell),);
    });

    const filtersSelectRadioCatergory = [
      ...this.block.querySelectorAll(
        this.selectors.filtersSelectRadioCatergory,
      ),
    ];

    filtersSelectRadioCatergory.forEach(radio => {
      this.initToggleCategory(radio);
    });

    this.triggerChange();

    this.initNotice();

    const { category } = this.getState();

    if (category) {
      const radioSelected = this.block.querySelector(
        `${this.selectors.filtersSelectRadio}[value="${category}"]`,
      );

      if (radioSelected) {
        this.toggleCategory(radioSelected);
      }
    }
  }

  initNotice() {
    const noticeArchived = this.block.querySelector(
      this.selectors.noticeArchived,
    );

    const cookieName = 'documentation_notice_archived';

    if (noticeArchived) {
      const noticeClose = noticeArchived.querySelector(
        this.selectors.noticeClose,
      );

      noticeClose.addEventListener('click', () => {
        sessionStorage.setItem(cookieName, true);

        noticeArchived.classList.add(this.classes.noticeHidden);
      });
    }

    const radiosStatus = this.block.querySelectorAll([
      this.selectors.radioStatus,
    ]);

    radiosStatus.forEach(radioStatus => {
      radioStatus.addEventListener('change', () => {
        const notice = this.block.querySelector(this.selectors.notice);

        if (
          radioStatus.value === 'archived' &&
          !sessionStorage.getItem(cookieName)
        ) {
          notice.classList.remove(this.classes.noticeHidden);
        } else {
          notice.classList.add(this.classes.noticeHidden);
        }
      });
    });
  }

  initToggleCategory(radio) {
    radio.addEventListener('change', () => this.toggleCategory(radio));

    const label = radio.nextElementSibling && radio.nextElementSibling.nodeName === 'LABEL' ? radio.nextElementSibling : false;

    if (label) {
      label.addEventListener('mouseup', event => DocumentationItem.tryDeselect(radio, event), false);
    }
  }

  static tryDeselect(radio, event) {
    if (radio.checked && radio.dataset.allowUncheck !== undefined) {
      event.preventDefault();
      event.stopPropagation();

      setTimeout(() => {
        radio.checked = false; // eslint-disable-line no-param-reassign
        radio.dispatchEvent(new Event('change'));
      }, 60);
    }
  }

  toggleCategory(radio) {
    if (!radio.checked) {
      radio = this.block.querySelector(this.selectors.filtersSelectRadioChecked); // eslint-disable-line no-param-reassign
    }

    const level = parseInt(radio.dataset.level, 10);

    const value = parseInt(radio.value, 10);

    const categories = this.block.querySelector(this.selectors.categories);
    const { items } = categories.dataset;

    const categoriesArray = JSON.parse(items);

    const parent = this.block.querySelector(
      `[data-category-parent="${level + 1}"]`,
    );

    let nextParent = parent;

    while (nextParent) {
      nextParent.innerHTML = '';
      nextParent = this.block.querySelector(
        `[data-category-parent="${
          parseInt(nextParent.dataset.categoryParent, 10) + 1
        }"]`,
      );
    }

    if (parent) {
      parent.innerHTML = '';

      const categoryTemplate = this.block.querySelector(
        this.selectors.categoryTemplate,
      );

      const childrens = categoriesArray.filter(item => item.parent === value);

      childrens.forEach(item => {
        const categoryHTML = document.implementation.createHTMLDocument('');

        categoryHTML.body.innerHTML = categoryTemplate.innerHTML;

        const filtersSelect = categoryHTML.querySelector(
          this.selectors.filtersSelect,
        );

        const filtersSelectRadio = categoryHTML.querySelector(
          this.selectors.filtersSelectRadio,
        );

        filtersSelectRadio.value = item.id;
        filtersSelectRadio.setAttribute('name', `category_${level + 1}`);
        filtersSelectRadio.id = `cat_${item.id}`;
        filtersSelectRadio.dataset.level = level + 1;
        filtersSelectRadio.dataset.allowUncheck = true;

        this.initToggleCategory(filtersSelectRadio);

        const label = categoryHTML.querySelector('label');

        label.setAttribute('for', `cat_${item.id}`);
        const filtersSelectLabel = categoryHTML.querySelector(
          this.selectors.filtersSelectLabel,
        );

        filtersSelectLabel.textContent = item.name;

        if (item.use_tooltip) {
          const tooltip = label.querySelector(this.selectors.tooltip);
          const tooltipText = tooltip.querySelector(this.selectors.tooltipText);

          tooltipText.textContent = item.tooltip;
          tooltip.classList.remove(this.classes.tooltipHidden);
        }

        parent.appendChild(filtersSelect);

        if (childrens.length === 1) {
          filtersSelectRadio.setAttribute('checked', 'checked');

          filtersSelectRadio.dispatchEvent(new Event('change'));
        }
      });
    }

    this.block.querySelector(this.selectors.offset).value = 0;

    this.triggerChange();
  }

  sortBy(sortBy, headerCell) {
    const isAsc = headerCell.dataset.sortOrder === 'asc';

    const headerCellInner = [
      ...this.block.querySelectorAll(this.selectors.headerCellInner),
    ];

    headerCellInner.forEach(cell => {
      cell.dataset.sortOrder = ''; // eslint-disable-line no-param-reassign
    });

    const tableBody = this.block.querySelector(this.selectors.tableBody);

    headerCell.dataset.sortOrder = isAsc ? 'desc' : 'asc'; // eslint-disable-line no-param-reassign

    [ ...this.block.querySelectorAll(this.selectors.row) ]
      .sort(DocumentationItem.comparer(sortBy, !isAsc))
      .forEach(tr => {
        const next = tr.nextElementSibling;

        tableBody.appendChild(tr);
        tableBody.appendChild(next);
      });

    this.triggerChange();
  }

  static comparer(field, asc) {
    return (aItem, bItem) =>
      ((v1, v2) =>
        v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ?
          parseFloat(v1) - parseFloat(v2) :
          (v1 || '').toString().localeCompare(v2))(
        DocumentationItem.getCellValue(asc ? aItem : bItem, field),
        DocumentationItem.getCellValue(asc ? bItem : aItem, field),
      );
  }

  static getCellValue(tr, field) {
    return tr.dataset[field]; // eslint-disable-line class-methods-use-this
  }

  nextPage(delta = 1, button = false) {
    const { pageLimit } = this.getState();

    const offset = parseInt(
      this.block.querySelector(this.selectors.offset).value,
      10,
    );

    this.setOffset(offset + pageLimit * delta, button); // eslint-disable-line no-mixed-operators
  }

  setOffset(offset, button = false) {
    this.block.querySelector(this.selectors.offset).value = offset;

    this.triggerChange();

    this.scrollToFirstItem(button);
  }

  // eslint-disable-next-line class-methods-use-this
  scrollToFirstItem(button) {
    let topMargin = 300;

    if (button) {
      const parent = button.closest('.b-documentation, .b-sw-downloads');

      if (parent) {
        const table = parent.querySelector('.b-documentation__container--table, .b-sw-downloads__container--table');

        if (table) {
          const elementRect = table.getBoundingClientRect();

          topMargin = elementRect.top + window.scrollY - (window.innerHeight / 2);
        }
      }
    }

    setTimeout(() => {
      window.scrollTo({
        top: topMargin,
        behavior: 'smooth',
      });
    }, 100);
  }

  getCategoryDefaultRadio() {
    return this.block.querySelector('[name="category_1"]:first-child');
  }

  getCategoryDefaultValue() {
    return this.categoryDefault;
  }

  resetFilters() {
    this.block.querySelector(this.selectors.filtersQueryInput).value = '';
    this.block.querySelector(this.selectors.selectDocumentType).value = '';
    this.block.querySelector(this.selectors.statusLatest).checked = true;

    const categoryN1 = this.block.querySelector(
      `${this.selectors.category1}[value="${this.categoriesDefault[0]}"]`,
    );

    if (categoryN1) {
      categoryN1.checked = true;
      categoryN1.dispatchEvent(new Event('change'));

      const categoryN2 = this.block.querySelector(
        `${this.selectors.category2}[value="${this.categoriesDefault[1]}"]`,
      );

      if (categoryN2) {
        categoryN2.checked = true;
        categoryN2.dispatchEvent(new Event('change'));

        const categoryN3 = this.block.querySelector(
          `${this.selectors.category3}[value="${this.categoriesDefault[2]}"]`,
        );

        if (categoryN3) {
          categoryN3.checked = true;
          categoryN3.dispatchEvent(new Event('change'));
        }
      }
    }

    const notices = [ ...this.block.querySelectorAll(this.selectors.notice) ];

    notices.forEach(notice =>
      notice.classList.add(this.classes.noticeHidden),);

    this.triggerChange();
  }

  triggerChange() {
    const rows = [ ...this.block.querySelectorAll(this.selectors.row) ];

    const offset = parseInt(
      this.block.querySelector(this.selectors.offset).value,
      10,
    );

    const { status, query, pageLimit, documentType, hasFilters, category } =
      this.getState();
    let numVisible = 0;
    let total = 0;

    if (hasFilters) {
      this.block
        .querySelector(this.selectors.reset)
        .classList.remove(this.classes.resetHidden);
    } else {
      this.block
        .querySelector(this.selectors.reset)
        .classList.add(this.classes.resetHidden);
    }

    const queryRegExp = query ?
      new RegExp(query.toLowerCase().trim().replace(/\s+/gu, '|'), 'u') :
      false;

    rows.forEach(row => {
      const {
        status: rowStatus,
        title: rowTitle,
        documentTypes,
        documentCategories,
      } = row.dataset;

      const documentTypesArray = documentTypes.split(',');

      const filters = query ?
        [ !queryRegExp || rowTitle.toLowerCase().search(queryRegExp) >= 0 ] :
        [
          status === rowStatus,
          !documentType ||
              (documentType && documentTypesArray.includes(documentType)),
          !category || (category && documentCategories.includes(category)),
        ];

      const visible = filters.every(condition => condition);

      if (visible) {
        total += 1;
      }

      if (visible && numVisible < pageLimit && total > offset) {
        numVisible += 1;

        row.classList.remove(this.classes.rowHidden);
      } else {
        row.classList.add(this.classes.rowHidden);
      }
    });

    const pagingCurrent =
      total > 0 ? `${offset + 1}-${Math.min(offset + pageLimit, total)}` : '0';

    this.block.querySelector(this.selectors.pagingCurrent).textContent =
      pagingCurrent;

    this.block.querySelector(this.selectors.pagingTotal).textContent = total;

    this.buildPaging(total, offset, pageLimit);
  }

  createPagingButton({
    text,
    mainClassName,
    classNames,
    onClick,
  } = {}) {
    const button = document.createElement('div');

    button.classList.add(mainClassName || this.classes.page);

    if (text) {
      button.innerHTML = text;
    }

    if (classNames && Array.isArray(classNames)) {
      classNames.filter(Boolean).forEach(className => button.classList.add(className));
    }

    if (onClick) {
      button.addEventListener('click', onClick);
    }

    return button;
  }

  buildPaging(total, offset, pageLimit) {
    const pagingBar = this.block.querySelector(this.selectors.pagingBar);

    if (!pagingBar) {
      return;
    }

    const createButton = this.createPagingButton.bind(this);

    const isNextDisabled = total < offset + pageLimit;
    const isPrevDisabled = offset <= 0;

    const prev = createButton({
      text: 'Back',
      classNames: [ this.classes.pageArrow, this.classes.pagePrev, isPrevDisabled && this.classes.pageDisabled ],
      onClick: () => this.nextPage(-1, prev),
    });

    const next = createButton({
      text: 'Next',
      classNames: [ this.classes.pageArrow, this.classes.pageNext, isNextDisabled && this.classes.pageDisabled ],
      onClick: () => this.nextPage(1, next),
    });

    pagingBar.innerHTML = '';
    pagingBar.appendChild(prev);

    const currentPage = Math.ceil((offset + 1) / pageLimit) || 1;
    const lastPage = Math.ceil(total / pageLimit);

    const visibleButtons = 3;

    let start = currentPage - visibleButtons;
    let finish = currentPage + visibleButtons;

    while (start < 1) {
      start += 1;
      if (finish - start < visibleButtons) {
        finish += 1;
      }
      if (finish > lastPage) {
        finish = lastPage;
      }
    }

    if (start === 2) {
      start = visibleButtons;
    }

    while (finish > lastPage) {
      finish -= 1;

      if (finish - start < visibleButtons) {
        start -= 1;
      }

      if (start < 1) {
        start = 1;
      }
    }

    if (lastPage - finish < 2) {
      finish = lastPage;
    }

    start = start || 1;
    finish = finish || 1;

    if (start > 2) {
      pagingBar.appendChild(createButton({
        text: '1',
        onClick: () => this.setOffset(0),
      }));

      pagingBar.appendChild(createButton({
        mainClassName: this.classes.pageEllipsis,
      }));
    }

    for (let i = start; i <= finish; i++) {
      pagingBar.appendChild(createButton({
        text: i,
        classNames: [ i === currentPage && this.classes.pageSelected ],
        onClick: () => this.setOffset((i - 1) * pageLimit),
      }));
    }

    if (lastPage - finish >= 2) {
      pagingBar.appendChild(createButton({
        mainClassName: this.classes.pageEllipsis,
      }));

      pagingBar.appendChild(createButton({
        text: lastPage,
        onClick: () => this.setOffset((lastPage - 1) * pageLimit),
      }));
    }

    pagingBar.appendChild(next);
  }

  getState() {
    const data = {
      status: this.block.querySelector(this.selectors.statusSelected).value,
      query: this.block.querySelector(this.selectors.filtersQueryInput).value,
      documentType: this.block.querySelector(this.selectors.selectDocumentType)
        .value,
      pageLimit: parseInt(
        this.block.querySelector(this.selectors.pageLimit).value,
        10,
      ),
    };

    const categoryN1 = this.block.querySelector(
      this.selectors.category1Checked,
    );
    const categoryN2 = this.block.querySelector(
      this.selectors.category2Checked,
    );
    const categoryN3 = this.block.querySelector(
      this.selectors.category3Checked,
    );

    const categories = [
      categoryN3 ? categoryN3.value : false,
      categoryN2 ? categoryN2.value : false,
      categoryN1 ? categoryN1.value : false,
    ].filter(Boolean);

    const categoriesNode = this.block.querySelector(this.selectors.categories);
    const categoriesArray = JSON.parse(categoriesNode.dataset.items);

    const categoriesData = categories.map(category =>
      categoriesArray.find(item => item.id === parseInt(category, 10))).reverse();

    const categoriesTitles = categoriesData.reduce((titles, category) => {
      if (category.second_title) {
        titles.secondTitle = category.second_title; // eslint-disable-line no-param-reassign
      }
      if (category.third_title) {
        titles.thirdTitle = category.third_title; // eslint-disable-line no-param-reassign
      }

      return titles;
    }, { secondTitle: '', thirdTitle: '' });

    const categoryHeaders = [
      ...this.block.querySelectorAll(this.selectors.categoryHeader),
    ];

    categoryHeaders.forEach(categoryHeader => {
      const { titleKey } = categoryHeader.dataset;

      if (categoriesTitles[titleKey]) {
        categoryHeader.textContent = categoriesTitles[titleKey]; // eslint-disable-line no-param-reassign
      }
    });

    data.category = categories.length > 0 ? categories.shift() : false;

    data.hasFilters = [
      data.status !== 'publish',
      data.query,
      data.documentType,
      data.category !== this.getCategoryDefaultValue(),
    ].some(value => value);

    return data;
  }
}

export default class Documentation {
  constructor() {
    this.selector = '.b-documentation';
  }

  bootstrap() {
    this.wrappers = [ ...document.querySelectorAll(this.selector) ];

    this.wrappers.forEach(wrapper => new DocumentationItem(wrapper));
  }
}
